<template>
  <v-col sm='12'>
    <v-row no-gutters>
      <v-col style='padding: 20px'>
        <v-card style='padding: 0 15px 25px 15px;'>
          <!-- header -->
          <v-card-header>
            <v-card-icon>
              <i class="fa fa-solid fa-cloud"></i>
            </v-card-icon>
            <h4 class="title">
              {{ $t("webChannel.StopWords.title") }}
            </h4>
          </v-card-header>

          <!-- form, textarea, maximunWords, minimumIncidences -->
          <v-card-content>
            <form class="form-horizontal" action method="post">

              <!-- textarea -->
              <v-layout class="textarea__stop-words">
                <label
                  :class="{
                    'text-success': canalWebData.isStopWordsEnable,
                    'text-danger': !canalWebData.isStopWordsEnable
                  }">
                </label>
                <v-layout>
                  {{ $t("webChannel.StopWords.subitems.exemple") }}
                </v-layout>
                <v-layout class="subtext">
                  {{ $t("webChannel.StopWords.subitems.inForSubtext") }}
                </v-layout>
                <v-layout solo>
                  <v-textarea
                    v-model='stopWords'
                    :placeholder="$t('webChannel.StopWords.subitems.inFor')"
                  />
                </v-layout>
              </v-layout>

              <!-- maximunWords -->
              <v-layout class="v-layout__inputs" style="margin-bottom: 10px">
                <v-row>
                  <v-col>
                    <p class="text">
                      {{
                        $t("webChannel.StopWords.subitems.maxWords")
                      }}
                    </p>
                    <p class="text">
                      {{
                        $t("webChannel.StopWords.subitems.maxWordsAccepted")
                      }}
                    </p>
                  </v-col>
                  <v-text-field
                    v-model="canalWebData.maximunWords"
                    type='number'
                    class="stop-word__inputs"
                    min='1'
                    max="50"
                    value="50"
                    :required="canalWebData.maximunWords > 0"
                    :rules="[rules.required, rules.maximunWordsValidation]"
                  />
                </v-row>
              </v-layout>

              <!-- minimumIncidences -->
              <v-layout class="v-layout__inputs">
                <v-row>
                  <v-col>
                    <p class="text">
                      {{
                        $t("webChannel.StopWords.subitems.minIncidence")
                      }}
                    </p>
                    <p class="text">
                      {{
                        $t("webChannel.StopWords.subitems.minIncidenceAccepted")
                      }}
                    </p>
                  </v-col>

                  <v-text-field
                    v-model="canalWebData.minimumIncidences"
                    type='number'
                    class="stop-word__inputs"
                    step="any"
                    v-card-icon min="3"
                    ref="input"
                    value="3"
                    :required="canalWebData.minimumIncidences > 0"
                    :rules="[rules.required, rules.minimumIncidencesValidation]"
                  />
                </v-row>
              </v-layout>

            </form>

          </v-card-content>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  watch: {
    stopWords (nV) {
      this.canalWebData.stopWords = nV.split('\n')
    }
  },
  data () {
    return {
      stopWords: Array.isArray(this.canalWebData.stopWords)
        ? this.canalWebData.stopWords.join('\n')
        : this.canalWebData.stopWords ?? this.$t('stopWords.inFor'),
      rules: {
        maximunWordsValidation: value => (value < 51 && value > 0) || this.$t('webChannel.StopWords.subitems.invalidValue'),
        minimumIncidencesValidation: value => (value > 2) || this.$t('webChannel.StopWords.subitems.invalidValue'),
        required: value => !!value || this.$t('webChannel.StopWords.subitems.required')
      }
    }
  },
  computed: {
    maximunWordsValidationMessage () {
      return value => (value > 51 && value < 0) && this.canalWebData?.maximunWords > 0
    },
    minimumIncidencesValidationMessage () {
      return value => (value < 3) && this.canalWebData?.minimumIncidences > 0
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-card {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14) !important;
}

::v-deep v-card-header {
  display: flex;
}

::v-deep v-card-icon {
  margin: 0 15px 15px 0;
  border-radius: 3px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
  background: linear-gradient(60deg, #66bb6a, #43a047);
  box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28),
  0 4px 20px 0px rgba(0, 0, 0, 0.12),
  0 7px 8px  -5px rgba(76, 175, 80, 0.2);
  padding: 15px;
}

::v-deep .fa {
  color: #fff;
  width: 33px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .title {
  color: #3c4858;
  margin-top: 15px;
}

::v-deep .layout,
.v-text-field {
  padding: 15px !important;
}

::v-deep .textarea__stop-words {
  flex-direction: column;
  padding: 0px !important;
}

::v-deep .layout.v-layout__inputs {
  justify-content: space-between;
  padding: 0 15px;
}

::v-deep .layout.v-layout__inputs input {
  margin-right: 15px;
  height: 40px;
}

::v-deep .v-input.stop-word__inputs {
  max-width: 150px;
}

.v-input.stop-word__inputs input {
  border: 0.5px solid #a8a8a8;
  border-radius: 4px;
  padding-left: 10px;
}

::v-deep .v-input input {
  max-height: 250px;
}

::v-deep .v-input.stop-word__inputs input[type="number"]::-webkit-inner-spin-button {
  cursor: pointer;
}

/* Ajustando componente para os navegadores*/
::v-deep .v-input.stop-word__inputs input[type="number"]::-webkit-outer-spin-button,
::v-deep .v-input.stop-word__inputs input[type="number"]::-webkit-inner-spin-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1em;
  border-left: 0.5px solid #a8a8a8;
  opacity: 1;
}

/* html */
::v-deep .v-input.stop-word__inputs input {
  border: 0.5px solid #a8a8a8;
  border-radius: 4px;
  padding-left: 10px;
}

::v-deep .v-input input {
  max-height: 250px;
}

::v-deep .v-input.stop-word__inputs input[type="number"]::-webkit-inner-spin-button {
  cursor: pointer;
}

/* Ajustando componente para os navegadores*/
::v-deep .v-input.stop-word__inputs input[type="number"]::-webkit-outer-spin-button,
::v-deep .v-input.stop-word__inputs input[type="number"]::-webkit-inner-spin-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1em;
  border-left: 0.5px solid #a8a8a8;
  opacity: 1;
}

::v-deep .v-input.stop-word__inputs input[type="number"]::-moz-outer-spin-button,
::v-deep .v-input.stop-word__inputs input[type="number"]::-moz-inner-spin-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1em;
  border-left: 0.5px solid #a8a8a8;
  opacity: 1;
}

/* Removendo linha padrão do componente */
::v-deep .stop-word__inputs > .v-input__control > .v-input__slot:after {
  background-color: currentColor;
  border-color: currentcolor;
  border-style: hidden !important;
  border-width: thin 0;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
}

::v-deep .stop-word__inputs > .v-input__control > .v-input__slot:before {
  border-color: inherit;
  border-style: hidden !important;
  border-width: thin 0 0;
}
.subtext {
  font-size: 12px;
  margin-top: -28px;
}

</style>
